/** Número de WhatsApp comercial, formato E.164 sem "+" (código país + DDD + número). */
export const WHATSAPP_NUMBER = '5548996982489'; // +55 48 99698-2489

export const WHATSAPP_DISPLAY = '+55 48 99698-2489';

/** Mensagem padrão pré-preenchida ao abrir o WhatsApp pelos CTAs do site. */
export const WHATSAPP_DEFAULT_MESSAGE =
  'Olá! Vim pelo site do AgilizaOS e gostaria de conhecer melhor o sistema.';

export function whatsappLink(message?: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message ?? WHATSAPP_DEFAULT_MESSAGE)}`;
}

export const site = {
  name: 'AgilizaOS',
  url: 'https://www.agilizaos.com.br',
  locale: 'pt-BR',
  email: 'contato@agilizaos.com.br',
  ogImage: '/og-image.png',
  description:
    'AgilizaOS é o ERP em nuvem que traz seu cliente de volta sozinho: lembrete automático de retorno por WhatsApp, cobrança automática e PDV integrado — com OS, estoque por filial e emissão fiscal automática como base.',
} as const;

export const nav: readonly { label: string; href: string }[] = [
  { label: 'Produto', href: '#produto' },
  { label: 'Como funciona', href: '#como-funciona' },
  { label: 'Para quem é', href: '#para-quem' },
  { label: 'Planos', href: '#planos' },
  { label: 'Dúvidas', href: '#faq' },
];
